import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

export interface RefundLineItem {
  lineItemId: string;
  quantity: number;
  amount: number; // cents
}

export interface RefundRequest {
  orderId: string;
  fullRefund: boolean;
  lineItems?: RefundLineItem[];
  reason?: string;
}

export interface RefundResponse {
  partner: any;
  order: any;
  paymentState: string;
}

@Injectable({providedIn: 'root'})
export class RefundService {
  constructor(private http: HttpClient) {}

  refund(req: RefundRequest): Observable<RefundResponse> {
    return this.http.post<RefundResponse>(`${environment.apiUrl}/orders/refund`, req);
  }
}
